import { render, staticRenderFns } from "./TransportSelect.vue?vue&type=template&id=3b39907e"
import script from "./TransportSelect.vue?vue&type=script&lang=ts"
export * from "./TransportSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports